import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { useRequestState } from "./useRequestState";
var CREATE_KEY = "postProduct";
var UPDATE_KEY = "patchProduct";
export var useSaveProduct = function () {
    var dispatch = useDispatch();
    var create = useRequestState(CREATE_KEY);
    var update = useRequestState(UPDATE_KEY);
    var createProduct = function (body) {
        dispatch(customRequestApis({
            requestKey: CREATE_KEY,
            method: "POST",
            path: "/asg/Api/V1/Project",
            body: { data: body },
        }));
    };
    var updateProduct = function (_a) {
        var id = _a.id, body = _a.body;
        dispatch(customRequestApis({
            requestKey: UPDATE_KEY,
            method: "PATCH",
            path: "/asg/Api/V1/Project/".concat(id),
            body: { data: body },
        }));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(CREATE_KEY));
            dispatch(clearCustomRequest(UPDATE_KEY));
        };
    }, []);
    return {
        createProduct: createProduct,
        updateProduct: updateProduct,
        createdProduct: create.data,
        updatedProduct: update.data,
        loadingCreate: create.loading,
        loadingUpdate: update.loading,
        errorCreate: create.error,
        errorUpdate: update.error,
        clearCreated: function () { return dispatch(clearCustomRequest(CREATE_KEY)); },
        clearUpdated: function () { return dispatch(clearCustomRequest(UPDATE_KEY)); },
    };
};
